export default {
  control: (styles, { isDisabled }) => ({
    ...styles,
    backgroundColor: isDisabled ? '#c2cfd6' : '#f6f3f3',
    borderColor: '#E87721',
    borderRadius: '3px',
    color: '#4d4d4d',
    ':hover': {
      ...styles[':hover'],
      boxShadow: '0 0 0 1px #E87721 inset',
      borderColor: '#E87721',
    },
    ':focus': {
      ...styles[':focus'],
      boxShadow: '0 0 0 1px #E87721 inset',
    },
    ':active': {
      ...styles[':active'],
      boxShadow: '0 0 0 1px #E87721 inset',
    },
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? '#E87721' : '#f6f3f3',
      paddingTop: '2px',
      paddingBottom: '2px',
      ':active': {
        ...styles[':active'],
        backgroundColor: '#E87721',
      },
      ':hover': {
        ...styles[':hover'],
        backgroundColor: '#E87721',
        color: '#f6f3f3',
      },
    }
  },
  input: (styles) => ({
    ...styles,
  }),
  placeholder: (styles) => ({ ...styles }),
  singleValue: (styles, { data }) => ({ ...styles }),
}
